class BannerAnimation {
  constructor(containers = document.querySelectorAll('.banner-animation-container')) {
    this.init(containers);
  }

  init(containers) {
    containers.forEach(container => this.setup(container));
  }

  setup(container) {
    const video = container.querySelector('video');

    // Prefer a real <img> (not the .banner-image__image wrapper)
    const imgEl = container.querySelector('.banner-image__image-container img');

    const textContent = container.querySelector('.banner-text-content');
    if (!textContent) return;

    if (video) {
      this.onVideoLoad(video, container);
      return;
    }

    if (imgEl && imgEl instanceof HTMLImageElement) {
      this.onImageLoad(imgEl, container);
      return;
    }

    // If we can't reliably detect media load, don't delay
    this.trigger(container);
  }

  onVideoLoad(video, container) {
    const triggerOnce = () => {
      this.trigger(container);
      video.removeEventListener('loadeddata', triggerOnce);
      video.removeEventListener('canplay', triggerOnce);
    };

    if (video.readyState >= 2) {
      this.trigger(container);
    } else {
      video.addEventListener('loadeddata', triggerOnce);
      video.addEventListener('canplay', triggerOnce);
      this.fallbackTrigger(container, 3000);
    }
  }

  onImageLoad(image, container) {
    const triggerOnce = () => {
      this.trigger(container);
      image.removeEventListener('load', triggerOnce);
    };

    if (image.complete && image.naturalHeight !== 0) {
      this.trigger(container);
    } else {
      image.addEventListener('load', triggerOnce);
      this.fallbackTrigger(container, 2000);
    }
  }

  fallbackTrigger(container, delay) {
    setTimeout(() => {
      if (!container.classList.contains('banner-loaded')) {
        this.trigger(container);
      }
    }, delay);
  }

  trigger(container) {
    // idempotent
    if (container.classList.contains('banner-loaded')) return;
    container.classList.add('banner-loaded');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new BannerAnimation();
});

document.addEventListener('shopify:section:load', (event) => {
  const containers = event.target.querySelectorAll('.banner-animation-container');
  if (containers.length) {
    new BannerAnimation(containers);
  }
});
